import React from "react";
import { fmt } from "@/lib/finance";

// Feb 2026 — high-visibility "Total for current selection" bar shown above
// the Expenses / Revenue ledgers. Recomputes instantly whenever the caller's
// filtered row-set changes — no separate API call, pure client-side sum.
// `valueFn` lets callers compute a currency-normalized amount per row
// (e.g. Revenue's INR-equivalent) instead of a flat field lookup.
export default function FinanceTotalsBar({ rows, amountField = "amount", valueFn, label = "expenses", testId }) {
  const getValue = valueFn || ((r) => Number(r?.[amountField] || 0));
  const total = (rows || []).reduce((s, r) => s + getValue(r), 0);
  const count = (rows || []).length;
  return (
    <div
      className="flex items-center justify-between gap-3 mb-3 px-4 py-2.5 rounded-sm bg-[#F54800]/[0.06] border border-[#F54800]/20"
      data-testid={testId}
    >
      <div className="text-xs font-medium text-slate-600">Total for current selection</div>
      <div className="flex items-baseline gap-2">
        <span className="font-display font-bold text-lg text-[#F54800]" data-testid={`${testId}-amount`}>{fmt(total)}</span>
        <span className="text-xs text-slate-500" data-testid={`${testId}-count`}>across {count} {label}</span>
      </div>
    </div>
  );
}
